import type { User } from "features/auth";
import { useQuery } from "react-query";
import { api } from "utils/api";
import { followerKeys } from "./queryKeys";

type ArtistFollowersResponse = {
  data: User[];
};

const getArtistFollowers = (artistId: string) =>
  api.get<ArtistFollowersResponse>(`/followers?artistId=${artistId}`);

/*
 * Get all followers for an Artist
 */
const useArtistFollowers = (artistId: string) =>
  useQuery(followerKeys.list(artistId), () => getArtistFollowers(artistId));

export { useArtistFollowers };
